import { QsehraClassDesignWizardState } from 'core/application/adminDashboard/benefitDetails/design/qsehra/productClass/getProductClassDesignWizardState'

import { NavItemProps } from '../../../../common/productClassWizardModal/models'
import SetAllowancesForm, { SetAllowancesFormProps } from '../components/setAllowancesForm'
import SetEligibleExpensesForm, { SetEligibleExpensesFormProps } from '../components/setEligibleExpensesForm'
import SetWaitingPeriodForm, { SetWaitingPeriodFormProps } from '../components/setWaitingPeriod'

export enum IchraProductClassWizard {
  SetEligibleExpenses = 'ichra-class-design-select-eligible-expenses',
  SetAllowances = 'ichra-class-design-set-allowance',
  SetWaitingPeriod = 'ichra-class-design-set-waiting-period',
}

export const IchraProductClassWizardNavItemsMapping: NavItemProps[] = [
  {
    key: IchraProductClassWizard.SetEligibleExpenses,
    component: SetEligibleExpensesForm,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.select-expense-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetEligibleExpensesFormProps => {
      return {
        productClassId: state ? state.id : '',
        reimbursementProduct: state ? state.reimbursementProduct : null,
      }
    },
  },
  {
    key: IchraProductClassWizard.SetAllowances,
    component: SetAllowancesForm,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-allowance-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetAllowancesFormProps => {
      return {
        productClassId: state ? state.id : null,
        familyAllowances: state ? state.familyAllowances ?? [] : [],
        offerSameAllowance: state ? state.offerSameAllowance : null,
      }
    },
  },
  {
    key: IchraProductClassWizard.SetWaitingPeriod,
    component: SetWaitingPeriodForm,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-waiting-period-tooltip',
    mapState: (state: QsehraClassDesignWizardState | undefined): SetWaitingPeriodFormProps => {
      return {
        productClassId: state ? state.id : '',
        waitingPeriod: state.waitingPeriod,
      }
    },
  },
]
